import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { LocalizationGroupSchema } from "./get-localization-groups";

export const createLocalizationGroup = {
  name: "createLocalizationGroup" as const,
  input: z.object({
    teamId: zExt.objectId(),
    name: z.string(),
    description: z.string(),
    countries: z.array(z.string()),
  }),
  output: z.object({ localizationGroup: LocalizationGroupSchema }),
};
